import { setListings } from '../setListings'
import { ListingsApi } from '../../api'

export const fetchListings = () => {
  return async dispatch => {
    const api = new ListingsApi()
    const listings = await api.getListings()
    dispatch(setListings(listings))
  }
}
